import { render, staticRenderFns } from "./DataStore.vue?vue&type=template&id=1bd51d19&"
import script from "./DataStore.vue?vue&type=script&lang=js&"
export * from "./DataStore.vue?vue&type=script&lang=js&"
import style0 from "./DataStore.vue?vue&type=style&index=0&id=1bd51d19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports